export default __webpack_public_path__ + "static/user-circle-2-bed0a27ba1b077191901d81f9a207844.png";